var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.barSeries[0].data.length > 0)?_c('v-card',{staticClass:"rounded-lg pa-4",attrs:{"flat":"","width":"100%","height":"100%"}},[_c('apexchart',{ref:"barChart",attrs:{"height":"100%","type":"bar","options":_vm.barOptions,"series":_vm.barSeries}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }